import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
//Mui components
import {
    Dialog,
    Tabs,
    Tab,
    Divider,
    Stack,
    DialogContent,
    DialogTitle,
    IconButton,
    Slide,
    Tooltip,
    Radio,
    RadioGroup,
    FormControl,
    FormControlLabel,
    TextField,
    DialogActions,
    MenuItem,
    Select,
    Button
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import DoneIcon from '@mui/icons-material/Done';
import useStyles from 'components/dialogs/controlTower/ControlTowerDialogs.style';
import ImageViewer from 'components/commons/ImageViewer/ImageViewer';
import DeleteIcon from '@mui/icons-material/Delete';
import StarHalfIcon from '@mui/icons-material/StarHalf';
//Facade
import Facade from 'core/Facade';
import { Add } from '@mui/icons-material';
import AlertAction from 'actions/AlertAction';

const DialogData = ({ open, onClose, editMode, beforeData, botData, nowData, name, url, closeNoSaving, newPrice }) => {

    const [tab, setTab] = useState(0);
    const [saveMode, setSaveMode] = useState('saveDefault');
    const [newData, setNewData] = useState(nowData);

    const [newAdditionalData, setNewAdditionalData] = useState([]);
    const [confirmDialog, setConfirmDialog] = useState(false);

    const [evaluationAdded, setEvaluationAdded] = useState(false);

    useEffect(() => {
        if (open) {
            if (nowData.marketplaceOffers) {
                const newMp = nowData.marketplaceOffers.map(m => structuredClone(m));
                setNewData({ ...nowData, marketplaceOffers: newMp });
            } else {
                setNewData(nowData);
            }
        }
    },[open]);

    const classes = useStyles();

    const changeTab = (_, newValue) => setTab(newValue);

    const copyCodeToClipboard = text => {
        navigator.clipboard.writeText(text);
    };

    const keyIsUnique = (key, checkOne) => {
        let res = 0;
        if (checkOne) {
            if (key === '') return true;
            newAdditionalData.forEach(additionalData => {
                if (additionalData[0] === key) res += 1;
            });
        } else {
            return newAdditionalData.map(additionalData => keyIsUnique(additionalData[0], true)).includes(true);
        }
        return res > 1;
    };

    const emptyAttribute = () => newAdditionalData.map(additionalData => additionalData[1] === '').includes(true) || (newData.additionalData.evaluation && Object.values(newData.additionalData.evaluation).includes(''));

    if (!beforeData.marketplaceOffers ||
        !botData.marketplaceOffers ||
        !beforeData.additionalData ||
        !botData.additionalData) return null;

    const maxMpOffers = Math.max(beforeData.marketplaceOffers.length, botData.marketplaceOffers.length, nowData.marketplaceOffers.length, newData.marketplaceOffers ? newData.marketplaceOffers.length : 0);
    const isAddData = Facade.isEmpty(beforeData.additionalData) && Facade.isEmpty(botData.additionalData) && Facade.isEmpty(nowData.additionalData);

    return (
        <Dialog
            open={open}
            onClose={closeNoSaving}
            classes={{ paper: classes.dataDialogContent }}
        >
            <DialogTitle className={classes.dataDialogTitle}>
                <IconButton onClick={closeNoSaving}>
                    <ArrowBackIcon />
                </IconButton>
                <div className={classes.dataDialogTitleTextContainer}>
                    {editMode ?
                        'Editer les données actuelles' :
                        <div className={classes.dataDialogTitleText}>
                            {name}
                        </div>
                    }
                    {editMode ?
                        <FormControl>
                            <RadioGroup
                                value={saveMode}
                                onChange={(e) => setSaveMode(e.target.value)}
                            >
                                <FormControlLabel value='saveDefault' control={<Radio size='small' style={{ padding: '5px' }} />} label='Sauvegarder les champs vierges' />
                                <FormControlLabel value='saveModified' control={<Radio size='small'style={{ padding: '5px' }} />} label='Sauvegarder le now' />
                            </RadioGroup>
                        </FormControl>
                        :
                        <div className={classes.dataUrl} onClick={() => Facade.openUrl(url)}> {url} </div>
                    }
                </div>
            </DialogTitle>
            <DialogContent>
                <Tabs
                    value={tab}
                    onChange={changeTab}
                    className={classes.dataTabs}
                >
                    <Tab label='Donnees aditionelles' />
                    <Tab label='Marketplace offers' disabled={maxMpOffers === 0} />
                </Tabs>
                <Slide direction='right' in={tab === 0} mountOnEnter unmountOnExit>
                    <Stack
                        direction='row'
                        spacing={3}>
                        <div className={classes.dataColumnLegend}>
                            <div className={classes.dataColumnLegendText}>
                                Availability
                            </div>
                            <div className={classes.dataColumnLegendText}>
                                Image url
                            </div>
                            {(!isAddData || newAdditionalData.length > 0) &&
                                <div className={classes.dataColumnLegendText}>
                                    Données additionelles
                                </div>
                            }
                        </div>
                        <div className={classes.dataColumn}>
                            <div className={classes.dataColumnTitle}>Before</div>
                            {beforeData.availability.length > 40 ?
                                <Tooltip title={beforeData.availability} placement='top'>
                                    <div className={classes.dataColumnText}>
                                        {beforeData.availability}
                                    </div>
                                </Tooltip>
                                :
                                <div className={classes.dataColumnText}>
                                    {beforeData.availability}
                                </div>
                            }
                            <div className={classes.dataColumnText}>
                                <div style={{ width: '85%' }}>
                                    <ImageViewer imageUrl={beforeData.imgUrl} displayImg={false} />
                                </div>
                                {beforeData.imgUrl &&
                                    <IconButton onClick={() => copyCodeToClipboard(beforeData.imgUrl)}>
                                        <CopyAllIcon />
                                    </IconButton>
                                }
                            </div>
                            {typeof beforeData.additionalData === 'object' && Object.entries(beforeData.additionalData).map(([key, value]) => typeof value === 'object' ?
                                <div className={classes.dataColumn} key={key}>
                                    <div className={classes.additionalDataColumnText}>{key} : </div>
                                    {Object.entries(value).map(([k, v]) => <div className={classes.dataColumnText} style={{ justifyContent: 'start', marginLeft: '35px' }} key={k}>
                                        <div className={classes.additionalDataColumnText}>{k} : </div> {v}
                                    </div>)
                                    }
                                </div>
                                :
                                <div className={classes.dataColumnText} style={{ justifyContent: 'start' }} key={key}>
                                    <div className={classes.additionalDataColumnText}>{key} : </div> {value}
                                </div>
                            )}
                        </div>
                        <Divider orientation='vertical' flexItem />
                        <div className={classes.dataColumn}>
                            <div className={classes.dataColumnTitle}>Bot</div>
                            {botData.availability.length > 40 ?
                                <Tooltip title={botData.availability} placement='top'>
                                    <div className={classes.dataColumnText}>
                                        {botData.availability}
                                    </div>
                                </Tooltip>
                                :
                                <div className={classes.dataColumnText}>
                                    {botData.availability}
                                </div>
                            }
                            <div className={classes.dataColumnText}>
                                <div style={{ width: '85%' }}>
                                    <ImageViewer imageUrl={botData.imgUrl} displayImg={false} />
                                </div>
                                {botData.imgUrl &&
                                    <IconButton onClick={() => copyCodeToClipboard(botData.imgUrl)}>
                                        <CopyAllIcon />
                                    </IconButton>
                                }
                            </div>
                            {typeof botData.additionalData === 'object' && Object.entries(botData.additionalData).map(([key, value]) => typeof value === 'object' ?
                                <div className={classes.dataColumn} key={key}>
                                    <div className={classes.additionalDataColumnText}>{key} : </div>
                                    {Object.entries(value).map(([k, v]) => <div className={classes.dataColumnText} style={{ justifyContent: 'start', marginLeft: '35px' }} key={k}>
                                        <div className={classes.additionalDataColumnText}>{k} : </div> {v}
                                    </div>)
                                    }
                                </div>
                                :
                                <div className={classes.dataColumnText} style={{ justifyContent: 'start' }} key={key}>
                                    <div className={classes.additionalDataColumnText}>{key} : </div> {value}
                                </div>
                            )}
                        </div>
                        <Divider orientation='vertical' flexItem />
                        <div className={classes.dataColumn}>
                            <div className={classes.dataColumnTitle}>Now</div>
                            {saveMode === 'saveDefault' ?
                                nowData.availability.length > 40 ?
                                    <Tooltip title={nowData.availability} placement='top'>
                                        <div className={classes.dataColumnText}>
                                            {nowData.availability}
                                        </div>
                                    </Tooltip>
                                    :
                                    <div className={classes.dataColumnText}>
                                        {nowData.availability}
                                    </div>
                                :
                                <TextField
                                    value={newData.availability}
                                    size='small'
                                    className={classes.dataDialogTextField}
                                    onChange={(e) => setNewData({ ...newData, availability: e.target.value })}
                                />
                            }
                            {saveMode === 'saveDefault' ?
                                <div className={classes.dataColumnText}>
                                    <div style={{ width: '85%' }}>
                                        <ImageViewer imageUrl={nowData.imgUrl} displayImg={false} />
                                    </div>
                                    {nowData.imgUrl &&
                                        <IconButton onClick={() => copyCodeToClipboard(nowData.imgUrl)}>
                                            <CopyAllIcon />
                                        </IconButton>
                                    }
                                </div>
                                :
                                <TextField
                                    value={newData.imgUrl}
                                    size='small'
                                    className={classes.dataDialogTextField}
                                    onChange={(e) => setNewData({ ...newData, imgUrl: e.target.value })}
                                />
                            }
                            {newData.additionalData && Object.entries(newData.additionalData).map(([key, value]) => typeof value === 'object' ?
                                <div className={classes.dataColumn} key={key}>
                                    <div className={classes.additionalDataColumnText}>{key} : </div>
                                    {Object.entries(value).map(([k, v]) => saveMode === 'saveDefault' ?
                                        <div className={classes.dataColumnText} style={{ justifyContent: 'start', marginLeft: '35px' }} key={k}>
                                            <div className={classes.additionalDataColumnText}>{k} : </div> {v}
                                        </div>
                                        :
                                        <TextField
                                            value={newData.additionalData[key][k]}
                                            size='small'
                                            error={newData.additionalData[key][k] === ''}
                                            key={k}
                                            label={k}
                                            style={{ width: 'calc(100% - 35px)', marginBottom: '7.5px', marginLeft: '35px', marginTop: '5px' }}
                                            onChange={(e) => setNewData({ ...newData, additionalData: { ...newData.additionalData, [key]: { ...newData.additionalData[key], [k]: e.target.value } } })}
                                        />
                                    )}
                                </div>
                                :
                                saveMode === 'saveDefault' ?
                                    <div className={classes.dataColumnText} style={{ justifyContent: 'start' }} key={key}>
                                        <div className={classes.additionalDataColumnText}>{key} : </div> {value}
                                    </div>
                                    :
                                    <TextField
                                        value={newData.additionalData[key]}
                                        size='small'
                                        label={key}
                                        className={classes.dataDialogTextField}
                                        onChange={(e) => setNewData({ ...newData, additionalData : { ...newData.additionalData, [key]: e.target.value } })}
                                    />
                            )}
                            {newAdditionalData.length > 0 &&
                                newAdditionalData.map(([k, v], index) => <div key={index} style={{ display: 'flex' }}>
                                    <TextField
                                        value={k}
                                        size='small'
                                        error={keyIsUnique(k,true)}
                                        label={'Nom de l\'attribut'}
                                        className={classes.dataDialogTextField}
                                        style={{ marginRight: '2px' }}
                                        onChange={(e) => {
                                            const add = newAdditionalData.slice(0);
                                            add[index][0] = e.target.value;
                                            setNewAdditionalData(add);
                                        }}
                                    />
                                    <TextField
                                        value={v}
                                        size='small'
                                        error={v === ''}
                                        label={'Valeur'}
                                        className={classes.dataDialogTextField}
                                        style={{ marginLeft: '2px' }}
                                        onChange={(e) => {
                                            const add = newAdditionalData.slice(0);
                                            add[index][1] = e.target.value;
                                            setNewAdditionalData(add);
                                        }}
                                    />
                                    <IconButton onClick={() => {
                                        const add = newAdditionalData.slice(0);
                                        add.splice(index, 1);
                                        setNewAdditionalData(add);
                                    }}>
                                        <DeleteIcon />
                                    </IconButton>
                                </div>
                                )
                            }
                            {saveMode === 'saveModified' &&
                                <>
                                    <Tooltip title={'Ajouter une donnée additionelle'}>
                                        <IconButton onClick={() => {
                                            setNewAdditionalData([...newAdditionalData, ['','']]);
                                        }}>
                                            <Add />
                                        </IconButton>
                                    </Tooltip>
                                    {evaluationAdded ?
                                        <Tooltip title={'Supprimer l\'évaluation'}>
                                            <IconButton
                                                onClick={() => {
                                                    if (Object.keys(newData.additionalData).includes('evaluation')) {
                                                        let nd = {};
                                                        Object.entries(newData.additionalData).forEach(([k,v]) => {
                                                            if (k !== 'evaluation') nd = { ...nd, [k]: v };
                                                        });
                                                        setNewData({ ...newData, additionalData: nd });
                                                        setEvaluationAdded(false);
                                                    }
                                                }}>
                                                <StarHalfIcon />
                                            </IconButton>
                                        </Tooltip>
                                        :
                                        <Tooltip title={'Ajouter une évaluation'}>
                                            <IconButton onClick={() => {
                                                if (!Object.keys(newData.additionalData).includes('evaluation')) {
                                                    setNewData({ ...newData, additionalData: { ...newAdditionalData.additionalData, evaluation: { count: '', rating: '', max_rating: '' } } });
                                                    setEvaluationAdded(true);
                                                }
                                            }}>
                                                <StarHalfIcon />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                </>
                            }
                        </div>
                    </Stack>
                </Slide>
                <Slide direction='left' in={tab === 1} mountOnEnter unmountOnExit>
                    <Stack
                        direction='row'
                        spacing={3}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            {[...Array(maxMpOffers)].map((_, index) =>
                                <div className={classes.mpColumnLegend} key={index}>
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnLegendText : classes.mpEditColumnLegendText}>
                                        Vendeur
                                    </div>
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnLegendText : classes.mpEditColumnLegendText}>
                                        Prix
                                    </div>
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnLegendText : classes.mpEditColumnLegendText}>
                                        Cout de livraison
                                    </div>
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnLegendText : classes.mpEditColumnLegendText}>
                                        Prix total
                                    </div>
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnLegendText : classes.mpEditColumnLegendText}>
                                        Stock
                                    </div>
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnLegendText : classes.mpEditColumnLegendText}>
                                        Availability
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className={classes.dataColumn}>
                            <div className={classes.dataColumnTitle}>Before</div>
                            {beforeData.marketplaceOffers.map((mpOffer, index) =>
                                <div key={index}>
                                    {index > 0 && <div className={classes.dataColumnTitle} />}
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnText : classes.mpEditColumnText}>
                                        {mpOffer.seller_name}
                                    </div>
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnText : classes.mpEditColumnText}>
                                        {mpOffer.price}
                                    </div>
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnText : classes.mpEditColumnText}>
                                        {mpOffer.shipping_cost}
                                    </div>
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnText : classes.mpEditColumnText}>
                                        {mpOffer.price + mpOffer.shipping_cost}
                                    </div>
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnText : classes.mpEditColumnText}>
                                        {mpOffer.stock}
                                    </div>
                                    {mpOffer.availability.length > 40 ?
                                        <Tooltip title={mpOffer.availability} placement='top'>
                                            <div className={saveMode=== 'saveDefault' ? classes.mpColumnText : classes.mpEditColumnText}>
                                                {mpOffer.availability}
                                            </div>
                                        </Tooltip>
                                        :
                                        <div className={saveMode=== 'saveDefault' ? classes.mpColumnText : classes.mpEditColumnText}>
                                            {mpOffer.availability}
                                        </div>
                                    }
                                </div>
                            )}
                        </div>
                        <Divider orientation='vertical' flexItem />
                        <div className={classes.dataColumn}>
                            <div className={classes.dataColumnTitle}>Bot</div>
                            {botData.marketplaceOffers.map((mpOffer, index) =>
                                <div key={index}>
                                    {index > 0 && <div className={classes.dataColumnTitle} />}
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnText : classes.mpEditColumnText}>
                                        {mpOffer.seller_name}
                                    </div>
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnText : classes.mpEditColumnText}>
                                        {mpOffer.price}
                                    </div>
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnText : classes.mpEditColumnText}>
                                        {mpOffer.shipping_cost}
                                    </div>
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnText : classes.mpEditColumnText}>
                                        {mpOffer.price + mpOffer.shipping_cost}
                                    </div>
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnText : classes.mpEditColumnText}>
                                        {mpOffer.stock}
                                    </div>
                                    {mpOffer.availability.length > 40 ?
                                        <Tooltip title={mpOffer.availability} placement='top'>
                                            <div className={saveMode=== 'saveDefault' ? classes.mpColumnText : classes.mpEditColumnText}>
                                                {mpOffer.availability}
                                            </div>
                                        </Tooltip>
                                        :
                                        <div className={saveMode=== 'saveDefault' ? classes.mpColumnText : classes.mpEditColumnText}>
                                            {mpOffer.availability}
                                        </div>
                                    }
                                </div>
                            )}
                        </div>
                        <Divider orientation='vertical' flexItem />
                        <div className={classes.dataColumn}>
                            <div className={classes.dataColumnTitle}>Now</div>
                            {newData.marketplaceOffers && newData.marketplaceOffers.map((mpOffer, index) =>
                                <div key={index}>
                                    {index > 0 && <div className={classes.dataColumnTitle} />}
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnText : classes.mpEditColumnText}>
                                        {saveMode=== 'saveDefault' ?
                                            mpOffer.seller_name
                                            :
                                            <TextField
                                                value={newData.marketplaceOffers[index].seller_name}
                                                size='small'
                                                className={classes.mpDialogTextField}
                                                onChange={(e) => {
                                                    const mp = newData.marketplaceOffers.slice();
                                                    mp[index].seller_name = e.target.value;
                                                    setNewData({ ...newData, marketplaceOffers: mp });
                                                }}
                                            />
                                        }
                                    </div>
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnText : classes.mpEditColumnText}>
                                        {saveMode=== 'saveDefault' ?
                                            mpOffer.price
                                            :
                                            <TextField
                                                value={newData.marketplaceOffers[index].price}
                                                size='small'
                                                type='number'
                                                className={classes.mpDialogTextField}
                                                onChange={(e) => {
                                                    const mp = newData.marketplaceOffers.slice();
                                                    mp[index].price = e.target.value;
                                                    setNewData({ ...newData, marketplaceOffers: mp });
                                                }}
                                            />
                                        }
                                    </div>
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnText : classes.mpEditColumnText}>
                                        {saveMode=== 'saveDefault' ?
                                            mpOffer.shipping_cost
                                            :
                                            <TextField
                                                value={newData.marketplaceOffers[index].shipping_cost}
                                                size='small'
                                                type='number'
                                                className={classes.mpDialogTextField}
                                                onChange={(e) => {
                                                    const mp = newData.marketplaceOffers.slice();
                                                    mp[index].shipping_cost = e.target.value;
                                                    setNewData({ ...newData, marketplaceOffers: mp });
                                                }}
                                            />
                                        }
                                    </div>
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnText : classes.mpEditColumnText}>
                                        {saveMode=== 'saveDefault' ?
                                            parseFloat(mpOffer.shipping_cost) ?
                                                parseFloat(mpOffer.price) ?
                                                    parseFloat(mpOffer.shipping_cost) + parseFloat(mpOffer.price) : parseFloat(mpOffer.shipping_cost)
                                                : parseFloat(mpOffer.price) ?
                                                    parseFloat(mpOffer.price) : 0
                                            :
                                            parseFloat(newData.marketplaceOffers[index].shipping_cost) ?
                                                parseFloat(newData.marketplaceOffers[index].price) ?
                                                    parseFloat(newData.marketplaceOffers[index].shipping_cost) + parseFloat(newData.marketplaceOffers[index].price) : parseFloat(newData.marketplaceOffers[index].shipping_cost)
                                                : parseFloat(newData.marketplaceOffers[index].price) ?
                                                    parseFloat(newData.marketplaceOffers[index].price) : 0
                                        }
                                    </div>
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnText : classes.mpEditColumnText}>
                                        {saveMode=== 'saveDefault' ?
                                            mpOffer.stock
                                            :
                                            <FormControl fullWidth>
                                                <Select
                                                    value={newData.marketplaceOffers[index].stock}
                                                    size='small'
                                                    className={classes.mpDialogTextField}
                                                    onChange={(e) => {
                                                        const mp = newData.marketplaceOffers.slice();
                                                        mp[index].stock = e.target.value;
                                                        setNewData({ ...newData, marketplaceOffers: mp });
                                                    }}
                                                >
                                                    <MenuItem value={'en stock'}>En stock</MenuItem>
                                                    <MenuItem value={'sup. 48h'}>Sup 48h</MenuItem>
                                                    <MenuItem value={'rupture'}>Rupture</MenuItem>
                                                    <MenuItem value={''}>Inconnu</MenuItem>
                                                </Select>
                                            </FormControl>
                                        }
                                    </div>
                                    <div className={saveMode=== 'saveDefault' ? classes.mpColumnText : classes.mpEditColumnText}>
                                        {saveMode=== 'saveDefault' ?
                                            mpOffer.availability.length > 40 ?
                                                <Tooltip title={mpOffer.availability} placement='top'>
                                                    {mpOffer.availability}
                                                </Tooltip>
                                                :
                                                mpOffer.availability
                                            :
                                            <TextField
                                                value={newData.marketplaceOffers[index].availability}
                                                size='small'
                                                className={classes.mpDialogTextField}
                                                onChange={(e) => {
                                                    const mp = newData.marketplaceOffers.slice();
                                                    mp[index].availability = e.target.value;
                                                    setNewData({ ...newData, marketplaceOffers: mp });
                                                }}
                                            />
                                        }
                                    </div>
                                </div>
                            )}
                            {saveMode === 'saveModified' &&
                                <IconButton onClick={() => {
                                    const emptyMp = {
                                        availability: '',
                                        price: '',
                                        seller_name: '',
                                        shipping_cost: '',
                                        seller_url: '',
                                        shipping_info: '',
                                        stock: ''
                                    };
                                    const newMp = newData.marketplaceOffers.slice();
                                    newMp.push(emptyMp);
                                    setNewData({ ...newData, marketplaceOffers: newMp });
                                }}>
                                    <Add />
                                </IconButton>
                            }
                        </div>
                    </Stack>
                </Slide>
            </DialogContent>
            {editMode &&
                <DialogActions>
                    <IconButton onClick={() => {
                        if (keyIsUnique() || emptyAttribute()) {
                            AlertAction.open('error','Attribut non unique ou vide', 'top-right');
                        } else {
                            if (editMode && newData.marketplaceOffers.length > 0) {
                                if (parseFloat(newData.marketplaceOffers[0].price) + parseFloat(newData.marketplaceOffers[0].shipping_cost) !== newPrice) {
                                    setConfirmDialog(true);
                                    return;
                                }
                            }
                            if (newAdditionalData.length > 0) {
                                newAdditionalData.forEach(([k,v]) => k !== '' ? newData.additionalData = { ...newData.additionalData, [k]: v }:null);
                            }
                            saveMode === 'saveModified' ? onClose(newData): onClose();
                        }
                    }}>
                        <DoneIcon />
                    </IconButton>
                </DialogActions>}
            <Dialog
                open={confirmDialog}
                onClose={() => setConfirmDialog(false)}>
                <DialogContent>
                    Le prix saisi ne correspond pas à celui de la première offre MarketPlace, si vous validez alors toutes les données des MP seront suprimées
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmDialog(false)}>Annuler</Button>
                    <Button onClick={() => {
                        if (newAdditionalData.length > 0) {
                            newAdditionalData.forEach(([k,v]) => k !== '' ? newData.additionalData = { ...newData.additionalData, [k]: v }:null);
                        }
                        setConfirmDialog(false);
                        saveMode === 'saveModified' ? onClose(newData): onClose();
                    }} autoFocus>
                        Agree
                    </Button>
                </DialogActions>
            </Dialog>
        </Dialog>
    );

};

DialogData.propTypes = {
    beforeData: PropTypes.object,
    botData: PropTypes.object,
    closeNoSaving: PropTypes.func,
    datas: PropTypes.object,
    editMode: PropTypes.bool,
    name: PropTypes.string,
    newPrice: PropTypes.number,
    nowData: PropTypes.object,
    onClose: PropTypes.func,
    open: PropTypes.bool,
    url: PropTypes.string
};

export default DialogData;
